module.exports = __webpack_public_path__ + "static/media/uaslp-gray.f317012a.png";